import React from 'react'
import SnippeSection from './SnippeSection'


export default function Js() {
    let d = ["const MyFunc = (para) => {\n    //code\n}"]
    let e = ["console.log(//code)"]
    return (
        <>
            <h1 className='text-6xl my-color text-white text-center py-3 w-4/5 m-auto font-semibold rounded-3xl my-4 border-2 border-slate-900'>JavaScript</h1>
            <SnippeSection title="af - An Arrrow function in js" locate="right" code={d} />
            <SnippeSection title="log - A Sample console log" locate="" code={e} />
        </>
    )
}
